import React, { useState, useEffect, useCallback } from "react";
import ClientsTable from "./tables/ClientsTable";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../axios";
import Chart from "react-apexcharts";
// import Autosuggest from 'react-autosuggest';

import { userLogout } from "../Actions";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import salcitLogo from "../Assets/images/Swaasa.png";
import Icon from "../Assets/images/Icon.png";
import ClipLoader from "react-spinners/ClipLoader";
import { bottomNavigationActionClasses } from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';
// import Slider from "@mui/material/Slider";

const SuperAdmin = (props) => {
  // var rowss = [];
  var patients = 0;
  var assessments = 0;
  const [pieData, setPieData] = useState([]);
  const [pieLabels, setPieLabels] = useState([]);
  const [sortpieData, setsortPieData] = useState([]);
  const [sortpieLabels, setsortPieLabels] = useState([]);
  const [total_patients, setTotal_patients] = useState();
  const [total_assessments, setTotal_assessments] = useState();
  const [total_organizations, setTotal_organizations] = useState();
  const [total_DocCount, setTotal_DocCount] = useState();

  const [loading, setLoading] = useState(true);
  const [rowss, setRowss] = useState();

  const [lastKey, setLastKey] = useState("");
  // const [userProps, setUserProps] = useState();

  const [disable,setdisable] = useState(false)



  useEffect(() => {
    getDoctors();
  }, []);
  const getDoctors = () =>
    axios
      .get(`/getDoctors?page_limit=50`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        console.log(response);
        setTotal_DocCount(response.data.complete_doctors_count)
        setTotal_assessments(response.data.data.complete_assessments);
        setTotal_patients(response.data.data.complete_patients);
        setTotal_organizations(response.data.data.count);

        setLastKey(response.data.last_key);
        // console.log("lastkey",response.data.last_key);
        
        setRowss(response.data.data.users);
        if (response.data.last_key === "e30=") {
          setdisable(true);
        } else {
          setdisable(false);
        }
        try {
          setPieData(Object.values(response.data.data.usageDict));
          setPieLabels(Object.keys(response.data.data.usageDict));
        } catch (e) {
          console.log(e);
        }
        const pieDataLength = pieData.length;
        const sortedDict = Object.fromEntries(
          Object.entries(response.data.data.usageDict).sort(
            ([, a], [, b]) => b - a
          )
        );
        setsortPieData(Object.values(sortedDict));
        setsortPieLabels(Object.keys(sortedDict));
        console.log(sortedDict);
        setLoading(false);
      });
  let sum = 0;
  for (let i = 5; i < sortpieData.length; i++) {
    sum += sortpieData[i];
  }
  console.log(sum);

  // const [showAll, setShowAll] = useState(false);
  // const visibleItems = showAll ? sortpieLabels : sortpieLabels.slice(0, 5);

  // if (sortpieLabels.length <= 5) {
  //   return null;
  // }
  const logout = () => {
    props.userLogout();
    localStorage.clear();
    props.history.push("/");
  };

  if (loading) {
    return (
      <div className="loadingdiv">
        <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
      </div>
    );
  } else {
    return (
      <div className="superAdmin">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="static"
            sx={{ backgroundColor: "#f7f7f7", color: "black", marginBottom: 1 }}
          >
            <Toolbar>
              <Link to="/superadmin">
                <img className="superAdmin__logo" src={salcitLogo} alt="logo" />
              </Link>

              <Typography
                variant="h4"
                component="div"
                sx={{
                  flexGrow: 2,
                  marginTop: 1,
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#3d3d3d",
                  fontfamily: "IBM Plex Sans",
                }}
              >
                Super Admin
              </Typography>
              <Typography
                variant="p"
                component="div"
                sx={{
                  flexGrow: 0,
                  fontSize: 17,
                  borderRight: "solid 1px grey",
                }}
              >
                {localStorage.doctorId}&nbsp;&nbsp;&nbsp;
              </Typography>
              <Button
                color="inherit"
                sx={{
                  fontSize: 15,
                  textTransform: "none",
                  borderLeft: "black",
                }}
                onClick={() => {
                  logout();
                }}
              >
                {" "}
                <img
                  className="superAdmin__logout__logo"
                  src={Icon}
                  alt="logo"
                />{" "}
                Log out
              </Button>
            </Toolbar>
          </AppBar>
        </Box>
        <div className="superAdmin__content">
          <div className="superAdmin__sideBar">
            <div className="superAdmin__usageCard">
              <h5 className="superAdmin__usageCard__heading">
                Swaasa Usage so far
              </h5>
              <div className="superAdmin__usageCard__names">
                <p className="superAdmin__usageCard__assessments">
                  Total Organizations
                </p>
                <p className="superAdmin__usageCard__patients">Total Doctors</p>
              </div>
              <div className="superAdmin__usageCard__counts">
                <p className="superAdmin__usageCard__organizations">
                  {total_organizations}
                </p>
                <p className="superAdmin__usageCard__doctors">
                  {total_DocCount}
                </p>
              </div>

              <div className="superAdmin__usageCard__names">
                <p className="superAdmin__usageCard__assessments">
                  Total Patients
                </p>
                <p className="superAdmin__usageCard__patients">Total Assessment</p>
              </div>
              <div className="superAdmin__usageCard__counts">
                <p className="superAdmin__usageCard__totalAssessments">
                  {total_patients}
                </p>
                <p className="superAdmin__usageCard__totalPatients">
                  {total_assessments}
                </p>
              </div>

              
            </div>
            {/* <div className="superAdmin__piechart">
              <div className="superAdmin__piechart__content">
                <div className="superAdmin__piechart__content__card1">
                  <p className="superAdmin__piechart__content__card1__heading">
                    Total Organizations
                  </p>
                  <p className="superAdmin__piechart__content__card1__counts">
                    {total_organizations}
                  </p>
                  <p className="superAdmin__piechart__content__card1__info">
                    {" "}
                    The number of doctors / health workers enrolled in this
                    organization.
                  </p>
                </div>
                <div className="superAdmin__piechart__content__card2">
                  <p className="superAdmin__piechart__content__card2__heading">
                    Total Patients
                  </p>
                  <p className="superAdmin__piechart__content__card2__counts">
                    {total_patients}
                  </p>
                  <p className="superAdmin__piechart__content__card2__info">
                    {" "}
                    Total number of patients that have been registered by the
                    doctors and health workers
                  </p>
                </div>
              </div>
              <div className="superAdmin__piechart__content">
                <div className="superAdmin__piechart__content__card3">
                  <p className="superAdmin__piechart__content__card3__heading">
                    Total Assessments
                  </p>
                  <p className="superAdmin__piechart__content__card3__counts">
                    {total_assessments}
                  </p>
                  <p className="superAdmin__piechart__content__card3__info">
                    {" "}
                    Cumulative total of assessments conducted by this
                    organization.
                  </p>
                </div>
                <div className="superAdmin__piechart__content__card4">
                  <p className="superAdmin__piechart__content__card4__heading">
                    Yesterday's Assessments
                  </p>
                  <p className="superAdmin__piechart__content__card4__counts">
                    {total_patients}
                  </p>
                  <p className="superAdmin__piechart__content__card4__info">
                    {" "}
                    Total assessments that were done yesterday.
                  </p>
                </div>
              </div>
            </div> */}
            {/* <br/> */}
            <div className="superAdmin__piechart">
              <p className="superAdmin__piechart__heading">
                Client's Assessments
              </p>
              <div className="piechart">
                {/* <Chart
                  type="pie"
                  width={250}
                  height={300}
                  series={[sortpieData[0], sortpieData[1], sortpieData[2],sortpieData[3],sortpieData[4], sum]}
                  // series={pieData}
                  options={{
                    // colors: ['#FFA500', '#000000', '#0000FF' ],
                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      position: "bottom",
                    },

                    // title:{ text:"Client's Assessments"
                    // } ,
                    //  noData:{text:"Empty Data"},
                    // colors:["#f90000","#f0f"],
                    // labels: showAll ? sortpieLabels : sortpieLabels.slice(0, 3),
                    labels: [
                      sortpieLabels.slice(0, 1),
                      sortpieLabels.slice(1, 2),
                      sortpieLabels.slice(2, 3),
                      sortpieLabels.slice(3, 4),
                      sortpieLabels.slice(4, 5),
                      "Others",
                    ],
                    // labels:pieLabels
                  }}
                ></Chart> */}

              <div className="piechart">
                <Chart
                  type="pie"
                  width={250}
                  height={300}
                  series={[
                    sortpieData[0],
                    sortpieData[1],
                    sortpieData[2],
                    sortpieData[3],
                    sortpieData[4],
                    sum,
                  ]}
                  // series={pieData}
                  options={{
                    // colors: ['#FFA500', '#000000', '#0000FF' ],
                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      position: "bottom",
                    },
                    // title:{ text:"Client's Assessments"
                    // } ,
                    noData: [
                      {
                        url: `/clientadmin/${
                          rowss.filter(
                            (d) => d.hospitals == sortpieLabels.slice(0, 1)
                          )[0].loginId
                        }/${sortpieLabels.slice(0, 1)}`,
                        name: sortpieLabels.slice(0, 1)[0],
                      },
                      {
                        url: `/clientadmin/${
                          rowss.filter(
                            (d) => d.hospitals == sortpieLabels.slice(1, 2)
                          )[0].loginId
                        }/${sortpieLabels.slice(1, 2)}`,
                        name: sortpieLabels.slice(1, 2)[0],
                      },
                      {
                        url: `/clientadmin/${
                          rowss.filter(
                            (d) => d.hospitals == sortpieLabels.slice(2, 3)
                          )[0].loginId
                        }/${sortpieLabels.slice(2, 3)}`,
                        name: sortpieLabels.slice(2, 3)[0],
                      },
                      {
                        url: `/clientadmin/${
                          rowss.filter(
                            (d) => d.hospitals == sortpieLabels.slice(3, 4)
                          )[0].loginId
                        }/${sortpieLabels.slice(3, 4)}`,
                        name: sortpieLabels.slice(3, 4)[0],
                      },
                      {
                        url: `/clientadmin/${
                          rowss.filter(
                            (d) => d.hospitals == sortpieLabels.slice(4, 5)
                          )[0].loginId
                        }/${sortpieLabels.slice(4, 5)}`,
                        name: sortpieLabels.slice(4, 5)[0],
                      },
                    ],
                    // colors:["#f90000","#f0f"],
                    // labels: showAll ? sortpieLabels : sortpieLabels.slice(0, 3),
                    labels: [
                      // onClick ={handleRedirect}
                      sortpieLabels.slice(0, 1),
                      sortpieLabels.slice(1, 2),
                      sortpieLabels.slice(2, 3),
                      sortpieLabels.slice(3, 4),
                      sortpieLabels.slice(4, 5),
                      "Others",
                    ],
                    chart: {
                      events: {
                        dataPointSelection: (event, chartContext, config) => {
                          window.open(
                            config.w.config.noData.filter(
                              (d) =>
                                d.name ==
                                config.w.config.labels[config.dataPointIndex]
                            )[0].url,
                            "_blank"
                          );
                        },
                      },
                    },
                    // colors: [
                    //   "#4BC0C0",
                    //   "#FF6384",
                    //   "#36A2EB",
                    //   "#FFCE56",
                    //   "#8464a0",
                    //   "#2085ec",
                    // ],
                  }}
                ></Chart>
              </div>
              </div>
            </div>
          </div>
          <div className="superAdmin__table">
            <div className="superAdmin__usageCard__ourclients">
              <p>Our Clients</p>
            </div>

            <ClientsTable 
              rows={rowss} 
              lastKey={lastKey}
              disable={disable}
              // userProps={userProps} 
            />
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  doctors: state.doctors,
});
export default withRouter(connect(mapStateToProps, { userLogout })(SuperAdmin));